export const MAX_FILES_PER_UPLOAD = 50;
export const SYSTEM_FILE_NAMES = ['thumbs.db', 'desktop.ini', 'icon\r'];
export const SYSTEM_FOLDER_NAMES = ['__macosx'];
